import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AuthContext } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { UsersContext } from "../../context/UsersContext";
import { PlantsContext } from "../../context/PlantsContext";

const ProfileModal = ({ smShow, setSmShow }) => {
  const { handleLogout, clientDomain, googleAccess, isAuthenticated } =
    useContext(AuthContext);
  const { loggedUserInfo } = useContext(UsersContext);
  const { unDropIt } = useContext(PlantsContext);
  const navigate = useNavigate();

  return (
    <Modal
      className='profile-modal'
      size='sm'
      show={smShow}
      onHide={() => setSmShow(false)}
      aria-labelledby='example-modal-sizes-title-sm'
    >
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-sm'>
          {isAuthenticated ? loggedUserInfo.userName : "Effettua l'accesso!"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>
          {" "}
          {isAuthenticated
            ? loggedUserInfo.email
            : "Per poter segnalare zone di piantagione o acquistare piantine, partecipare alla chat e tanto altro ancora ti invitiamo ad effettuare l'accesso."}
        </span>
        <div className='profile-links mt-2 d-flex flex-row justify-content-between align-items-center'>
          <Link to={`${clientDomain}/login`} onClick={handleLogout}>
            {" "}
            {isAuthenticated ? "Logout" : "Login/registrati"}
          </Link>
          {isAuthenticated ? (
            <Link onClick={() => unDropIt()} to='/profile'>
              {" "}
              Modifica profilo
            </Link>
          ) : (
            <div
              onClick={() => {
                googleAccess(navigate, null, null);
              }}
              className='btn btn-link btn-link-google'
            >
              Accedi con Google
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
